module.exports = __webpack_public_path__ + "img/1c62501.png";